import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatDuration, formatViews } from "@/lib/movies";
import FavoriteButton from "@/components/feature/FavoriteButton";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-accent-400">
            <span className="h-3 w-0.5 rounded-full bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-semibold text-foreground-50 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-200 transition-colors hover:border-primary-500/60 hover:text-primary-300"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}